import { ComponentType, lazy } from 'react';

// Base type for any registry entry — used for runtime lookups in ModalHost
export interface AnyModalEntry {
  title?: string;
  component: React.LazyExoticComponent<ComponentType<{ onClose: () => void }>>;
}

export const modalRegistry = {
  confirmation: {
    title: 'Confirm',
    component: lazy(() =>
      import('../../components/modals/ConfirmModal').then((m) => ({
        default: m.ConfirmModal,
      }))
    ),
  },
  'remote-override': {
    title: 'Remote Override',
    component: lazy(() =>
      import('../../components/ComfortModalRemoteOverride').then((m) => ({
        default: m.ComfortModalRemoteOverride,
      }))
    ),
  },
  'schedule-event': {
    title: 'Schedule Event',
    component: lazy(() =>
      import('../../components/modals/ComfortModalScheduleEvent').then((m) => ({
        default: m.ComfortModalScheduleEvent,
      }))
    ),
  },
} as const;

export type ModalType = keyof typeof modalRegistry;

type ExtractProps<T extends ModalType> =
  (typeof modalRegistry)[T]['component'] extends React.LazyExoticComponent<ComponentType<infer P>>
    ? Omit<P, 'onClose'>
    : never;

// props is required when the modal has required fields, optional when all fields are optional
export type TypedOpenModal = <T extends ModalType>(
  type: T,
  // eslint-disable-next-line @typescript-eslint/no-empty-object-type
  ...args: {} extends ExtractProps<T> ? [props?: ExtractProps<T>] : [props: ExtractProps<T>]
) => void;
